<div class="flex gap-2 items-center">
    <div class="break-words" *ngIf="withText">{{getDecodedStatus()}}</div> <div class="p-2 rounded-full h-{{size}} w-{{size}} min-h-{{size}} min-w-{{size}}  animate-pulse" [ngClass]="getColorByStatus()"></div>
</div>
